import { render, staticRenderFns } from "./visitor_reservation_info.vue?vue&type=template&id=270523fb&scoped=true"
import script from "./visitor_reservation_info.vue?vue&type=script&lang=js"
export * from "./visitor_reservation_info.vue?vue&type=script&lang=js"
import style0 from "./visitor_reservation_info.vue?vue&type=style&index=0&id=270523fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270523fb",
  null
  
)

export default component.exports